'use client'
import { createTheme } from '@mui/material/styles';
import { Roboto } from 'next/font/google';
import { lightBlue, grey, blue } from '@mui/material/colors';

const roboto = Roboto({ 
    weight: ['300', '400', '500', '700'],
    subsets: ['latin'],
    display: 'swap',
});

const theme = createTheme({
    palette: {
        background: {
            default: grey[100],
         },
        primary: {
            main: '#102448',
        },
        secondary: {
            main: '#07b259'
        },
        info: {
            main: '#6d80a2'
        }
    },
    spacing: 10,
    typography: {
        fontFamily: 'Roboto, sans-serif',
        h1: { 
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 700,
            color: lightBlue[500],
        },

        h3: { 
            fontFamily: 'Roboto',
            fontWeight: 500,
            color: '#102448'
        },
        
    },
});

export default theme;